import { Colors } from '@blueprintjs/core';
import styled from 'styled-components';

export const ErrorFallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  width: 100%;
  padding: 20px;
  background-color: ${Colors.RED5};
`;

export const ErrorFallbackDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`;
